export default "__VITE_ASSET__Dr8WtSla__"